import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'

import MyhouseAuthMethod from '../MyhouseAuthMethod'

import style from './MyhouseAuthOwnerMethod.module.scss'

import BlindContent from '@Components/atoms/BlindContent'
import { lcsSend } from '@Helpers/lcs'
import { NDS_PROTOCOL } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  onOwnerAuthClick: any
  onResidentAuthClick: any
  ownerAuthCount: number
  residentAuthCount: number
  myHouseBaseAddress: any
  myHouseExtraAddress: any
}

const MyhouseAuthOwnerMethod: React.FC<Props> = ({ ownerAuthCount, residentAuthCount, onOwnerAuthClick, onResidentAuthClick, myHouseBaseAddress, myHouseExtraAddress }: Props) => {
  useEffect(() => {
    lcsSend(NDS_PROTOCOL.MY_HOUSE.AUTHENTICATION.SELECT_AUTH_TYPE)
  }, [])
  return (
    <section id="content" className={cx('article')} role="main">
      <BlindContent />
      <div className={cx('inner')}>
        <h3 className={cx('title')}>
          <em className={cx('emphasize')}>우리집 인증</em>을 위해
          <br /> 본인 명의 여부를 알려주세요
        </h3>
        <p className={cx('text')}>본인 명의 여부에 따라 인증 방법이 달라집니다.</p>
        <div className={cx('address')}>
          {myHouseBaseAddress}
          <br />
          {myHouseExtraAddress}
        </div>
        <MyhouseAuthMethod
          onClick={onOwnerAuthClick}
          title={'내 명의의 부동산입니다.'}
          error={'집주인 인증은 한 번 더 시도할 수 있습니다.'}
          errorCount={ownerAuthCount}
          tooltipText={'내 명의 부동산을 인증하면\n주택화재보험을 무료로 가입할 수 있어요!'}
        />
        <MyhouseAuthMethod
          onClick={onResidentAuthClick}
          title={'내 명의는 아니지만 이 집에 살고 있습니다.'}
          error={'입주민 인증은 한 번 더 시도할 수 있습니다.'}
          errorCount={residentAuthCount}
        />
      </div>
    </section>
  )
}

export default MyhouseAuthOwnerMethod
